export default __webpack_public_path__ + "static/media/Chhattisgarhi_af_1.901b9eac.mp3";